import { themeStyle } from '@repo/ui/theming';

export const defaultTheme = {
  fontSize: themeStyle.fontSize12,
  fontWeight: themeStyle.fontMedium,
  color: themeStyle.varInkMedium,
  height: '30px',
  lineHeight: '1.6',
  width: '100%',
};

export const popoverTheme = {
  padding: '0px',
};

export const suggestionsTheme = {
  height: '53px',
  width: '294px',

  colorSuggestion: themeStyle.varInkMain,
  colorSuggestionActive: themeStyle.varBrandMain,
  suggestionBackground: themeStyle.varInkBase,
  activeSuggestionBackground: themeStyle.varInkSuperLight,

  separator: `1px solid ${themeStyle.varInkSuperLight}`,
};
